import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { ColorPickerModule } from 'ngx-color-picker';
import { AngularFireModule } from 'angularfire2';
import { AngularFireStorageModule } from 'angularfire2/storage';

import { environment } from '@environments/environment';
import { ApplicationHttpClient, applicationHttpClientCreator } from './http-client';

import { AppRoutingModule } from './app-routing.module';
import { HomeRoutingModule } from './home/home-routing.module';
import { AppComponent } from './app.component';

import { DirectivesModule } from '@directives/directives.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material';
import { AuthComponent } from '@auth/auth.component';

import { AuthModule } from '@auth/auth.module';
import { HomeModule } from './home/home.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CompanyComponent } from '@company/company.component';

import { AppService } from './app.service';
import { DialogComponent } from '@dialog/dialog.component';

import { UserService } from '@user/user.service';
import { RoleService } from './role/role.service';
import { BottomSheetComponent } from './bottom-sheet/bottom-sheet.component';
import { ExceptionService } from '@exceptions-service';
import { SearchService } from '@dialog/dialog-search/dialog-search.service';
import { FormControlService } from '@base/form-controls.service';
import { FirebaseImagesService } from '@base/firebase-images.service';
import { Error404Component } from '@error404';
import { DialogSearchComponent } from '@dialog/dialog-search/dialog-search.component';
import { DialogGroupComponent } from './group/dialog-group/dialog-group.component';
import { DialogPopupInfoComponent } from '@dialog/dialog-popup-info/dialog-popup-info.component';
import { SearchUsersComponent } from '@dialog/search-users/search-users.component';
import { TagDialogComponent } from '@tag/tag-dialog/tag-dialog.component';
import { CompanySelectorComponent } from '@company/company-selector/company-selector.component';
import { ViewsDialogComponent } from '@base/tableau-dashboard/tableau-views-dialog/tableau-views-dialog.component';
import { FilterWorkbookComponent } from '@base/tableau-dashboard/tableau-filter-workbook/tableau-filter-workbook.component';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { DialogEtlComponent } from '@etl/dialog/dialog.component';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { rootReducers } from '@base/rootReducers';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { EtlModule } from '@etl/etl.module';
import { ParameterModule } from '@parameter/parameter.module';
import { TableauDashboardModule } from '@base/tableau-dashboard/tableau-dashboard.module';
@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    DashboardComponent,
    CompanyComponent,
    DialogComponent,
    BottomSheetComponent,
    Error404Component,
    DialogSearchComponent,
    DialogGroupComponent,
    DialogPopupInfoComponent,
    SearchUsersComponent,
    TagDialogComponent,
    CompanySelectorComponent,
    ViewsDialogComponent,
    FilterWorkbookComponent,
    DialogEtlComponent,
  ],
  imports: [
    BrowserModule,
    DeviceDetectorModule.forRoot(),
    BrowserAnimationsModule,
    FormsModule,
    MaterialModule,
    HttpClientModule,
    HttpModule,
    ReactiveFormsModule,
    ColorPickerModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireStorageModule,
    DirectivesModule,

    HomeRoutingModule,
    AppRoutingModule,

    AuthModule,
    HomeModule,
    StoreModule.forRoot(rootReducers),
    EffectsModule.forRoot([]),
    !environment.production ? StoreDevtoolsModule.instrument() : [],

    EtlModule,
    ParameterModule
  ],
  providers: [
    AppService,
    {
      provide: ApplicationHttpClient,
      useFactory: applicationHttpClientCreator,
      deps: [HttpClient]
    },
    UserService,
    RoleService,
    ExceptionService,
    SearchService,
    FormControlService,
    FirebaseImagesService,
  ],
  entryComponents: [
    DialogComponent,
    BottomSheetComponent,
    DialogSearchComponent,
    DialogGroupComponent,
    DialogPopupInfoComponent,
    SearchUsersComponent,
    TagDialogComponent,
    CompanySelectorComponent,
    ViewsDialogComponent,
    FilterWorkbookComponent,
    DialogEtlComponent,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
